<div class="landing-root bg-eco-cream text-eco-navy selection:bg-eco-gold selection:text-eco-navy min-h-screen">
  <!-- ============================================================ -->
  <!-- A. Top Nav (sticky)                                            -->
  <!-- ============================================================ -->
  <header
    class="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
    [ngClass]="scrolled() ? 'bg-eco-cream shadow-sm' : 'bg-transparent'"
  >
    <div class="container mx-auto px-6 h-16 flex items-center justify-between">
      <!-- Logo -->
      <a routerLink="/" class="flex items-center gap-2 shrink-0">
        <img
          src="../../../assets/app-icons/sun-mark.svg"
          alt="Johnston's Connected"
          class="mb-3 h-10 w-10 object-contain"
        />
        <span
          class="font-medium leading-tight text-xl transition-colors duration-300"
          [ngClass]="scrolled() ? 'text-eco-navy' : 'text-white'"
        >
          Johnston's Connected<span class="text-eco-gold">.</span>
        </span>
      </a>

      <!-- Center nav (desktop) -->
      <nav
        class="hidden laptop-min:flex items-center gap-8 text-sm font-medium transition-colors duration-300"
        [ngClass]="scrolled() ? 'text-eco-navy' : 'text-white'"
      >
        <button (click)="scrollToPlatform()" class="hover:text-eco-gold transition-colors cursor-pointer">Platform</button>
        <button (click)="scrollToForYou()" class="hover:text-eco-gold transition-colors cursor-pointer">For You</button>
        <button (click)="scrollToAbout()" class="hover:text-eco-gold transition-colors cursor-pointer">About</button>
        <button (click)="scrollToContact()" class="hover:text-eco-gold transition-colors cursor-pointer">Contact</button>
      </nav>

      <!-- Right actions -->
      <div class="flex items-center gap-4">
        <button
          (click)="scrollToContact()"
          class="hidden tablet-min:inline text-sm font-medium hover:text-eco-gold transition-colors duration-300 cursor-pointer"
          [ngClass]="scrolled() ? 'text-eco-navy' : 'text-white'"
        >
          Talk to a broker
        </button>
        <button
          (click)="router.navigate(['/login'])"
          class="inline-flex items-center gap-1 bg-eco-gold hover:bg-eco-gold-hover text-eco-navy font-medium text-xs px-3 py-2 rounded-full shadow-sm transition-colors cursor-pointer leading-none"
        >
          <span>Login</span>
        </button>
      </div>
    </div>
  </header>

  <!-- ============================================================ -->
  <!-- B. Hero (dark navy)                                            -->
  <!-- ============================================================ -->
  <section class="relative bg-eco-navy text-white overflow-hidden pt-32 pb-20">
    <!-- subtle grid -->
    <div class="absolute inset-0 pointer-events-none opacity-[0.07]"
      style="background-image: linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px); background-size: 64px 64px;">
    </div>

    <div class="container mx-auto px-6 relative z-10">
      <div class="grid grid-cols-1 laptop-min:grid-cols-12 gap-12 items-start">
        <!-- Left: copy + CTAs -->
        <div class="laptop-min:col-span-7">
          <h1 class="font-bold leading-[1.05] tracking-tight text-[3.5rem] tablet-max:text-[2.5rem]">
            The modern<br />
            <span class="font-display-italic text-eco-gold">commodity<br />trading</span> system.
          </h1>
          <p class="mt-8 text-lg text-white/70 max-w-xl leading-relaxed">
            With decades of combined experience in commodity exchange,
            Johnston's Connected delivers best-in-class solutions for
            <strong class="text-white font-medium">commodity traders</strong>.
            Live price discovery and trade execution — Enter Platform to connect.
          </p>
          <div class="mt-8 flex flex-wrap gap-3">
            <button
              (click)="router.navigate(['/login'])"
              class="flex items-center gap-1 bg-eco-gold hover:bg-eco-gold-hover text-eco-navy font-medium px-6 py-3 rounded-md shadow-lg shadow-eco-gold/20 transition-colors cursor-pointer"
            >
              Enter Platform <mat-icon class="!text-base !w-5 !h-5">chevron_right</mat-icon>
            </button>
            <button
              (click)="scrollToContact()"
              class="bg-white/5 hover:bg-white/10 text-white font-medium px-6 py-3 rounded-md border border-white/15 transition-colors cursor-pointer"
            >
              Talk to a broker
            </button>
          </div>
        </div>

        <!-- Right: live price card -->
        <div class="laptop-min:col-span-5 w-full">
          <div class="bg-eco-navy-700/70 backdrop-blur border border-white/10 rounded-2xl p-1 shadow-2xl shadow-black/40">
            <div class="px-5 py-3 border-b border-white/10 text-[11px] uppercase tracking-widest text-white/40 font-semibold">
              CAD / MT
            </div>
            <div class="divide-y divide-white/5">
              <!-- Row template repeated -->
              <div class="flex items-center px-5 py-3 gap-4">
                <span class="flex-1 text-sm font-medium">Canola · No. 1</span>
                <svg class="sparkline-svg text-emerald-400" viewBox="0 0 60 20" fill="none" stroke="currentColor" stroke-width="1.5">
                  <polyline points="0,14 10,12 20,13 30,9 40,10 50,6 60,7" />
                </svg>
                <span class="w-16 text-right text-sm font-semibold tabular-nums">682.20</span>
                <span class="w-14 text-right text-xs font-semibold text-emerald-400 tabular-nums flex items-center justify-end gap-1">
                  <mat-icon class="!text-[14px] !w-3 !h-3 leading-none">arrow_drop_up</mat-icon>+4.10
                </span>
              </div>
              <div class="flex items-center px-5 py-3 gap-4">
                <span class="flex-1 text-sm font-medium">Barley · Feed</span>
                <svg class="sparkline-svg text-emerald-400" viewBox="0 0 60 20" fill="none" stroke="currentColor" stroke-width="1.5">
                  <polyline points="0,12 10,13 20,11 30,12 40,10 50,9 60,8" />
                </svg>
                <span class="w-16 text-right text-sm font-semibold tabular-nums">298.50</span>
                <span class="w-14 text-right text-xs font-semibold text-emerald-400 tabular-nums flex items-center justify-end gap-1">
                  <mat-icon class="!text-[14px] !w-3 !h-3 leading-none">arrow_drop_up</mat-icon>+1.20
                </span>
              </div>
              <div class="flex items-center px-5 py-3 gap-4">
                <span class="flex-1 text-sm font-medium">Wheat · Durum</span>
                <svg class="sparkline-svg text-white/40" viewBox="0 0 60 20" fill="none" stroke="currentColor" stroke-width="1.5">
                  <polyline points="0,10 10,11 20,10 30,11 40,10 50,11 60,10" />
                </svg>
                <span class="w-16 text-right text-sm font-semibold tabular-nums">412.00</span>
                <span class="w-14 text-right text-xs font-semibold text-white/50 tabular-nums flex items-center justify-end gap-1">
                  <mat-icon class="!text-[14px] !w-3 !h-3 leading-none">remove</mat-icon>0.00
                </span>
              </div>
              <div class="flex items-center px-5 py-3 gap-4">
                <span class="flex-1 text-sm font-medium">Chickpeas · Kabuli</span>
                <svg class="sparkline-svg text-rose-400" viewBox="0 0 60 20" fill="none" stroke="currentColor" stroke-width="1.5">
                  <polyline points="0,7 10,9 20,8 30,11 40,10 50,13 60,14" />
                </svg>
                <span class="w-16 text-right text-sm font-semibold tabular-nums">915.50</span>
                <span class="w-14 text-right text-xs font-semibold text-rose-400 tabular-nums flex items-center justify-end gap-1">
                  <mat-icon class="!text-[14px] !w-3 !h-3 leading-none">arrow_drop_down</mat-icon>-3.20
                </span>
              </div>
              <div class="flex items-center px-5 py-3 gap-4">
                <span class="flex-1 text-sm font-medium">Flax · Brown</span>
                <svg class="sparkline-svg text-emerald-400" viewBox="0 0 60 20" fill="none" stroke="currentColor" stroke-width="1.5">
                  <polyline points="0,13 10,11 20,12 30,9 40,8 50,7 60,6" />
                </svg>
                <span class="w-16 text-right text-sm font-semibold tabular-nums">568.00</span>
                <span class="w-14 text-right text-xs font-semibold text-emerald-400 tabular-nums flex items-center justify-end gap-1">
                  <mat-icon class="!text-[14px] !w-3 !h-3 leading-none">arrow_drop_up</mat-icon>+2.40
                </span>
              </div>
            </div>
            <div class="px-5 py-3 text-right">
              <a (click)="router.navigate(['/login'])" class="text-xs font-semibold text-eco-gold hover:text-eco-gold-hover cursor-pointer">
                View all →
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Stats strip -->
      <div class="mt-16 grid grid-cols-1 tablet-min:grid-cols-3 gap-8 max-w-3xl">
        <div>
          <div class="text-3xl font-bold text-white tabular-nums">
            40,000<span class="text-eco-gold">+ MT</span>
          </div>
          <div class="mt-1 text-[11px] uppercase tracking-widest text-white/40 font-semibold">Volume Traded</div>
        </div>
        <div>
          <div class="text-3xl font-bold text-white tabular-nums">
            500<span class="text-eco-gold">+</span>
          </div>
          <div class="mt-1 text-[11px] uppercase tracking-widest text-white/40 font-semibold">Active Users</div>
        </div>
        <div>
          <div class="text-3xl font-bold text-white tabular-nums">
            30<span class="text-eco-gold">+ yrs</span>
          </div>
          <div class="mt-1 text-[11px] uppercase tracking-widest text-white/40 font-semibold">Brokerage Experience</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================ -->
  <!-- C. Platform features (cream)                                   -->
  <!-- ============================================================ -->
  <section #platformRef class="bg-eco-cream py-24">
    <div class="container mx-auto px-6">
      <div class="max-w-3xl">
        <div class="text-sm uppercase tracking-widest text-eco-gold font-semibold mb-3">The Platform</div>
        <h2 class="text-4xl tablet-max:text-3xl font-bold text-eco-navy leading-tight tracking-tight">
          Everything you need to discover price, execute trade, and settle contract.
        </h2>
        <p class="mt-5 text-base text-eco-navy/70 leading-relaxed">
          Elevate your trading with our powerful web-based platform, optimized for desktop.
          Effortlessly create bids and offers from a customizable list of commodity types and
          specifications, negotiate seamlessly with other users on their offers and bids, and
          access live trade data to stay ahead of ever-changing markets.
        </p>
      </div>

      <div class="mt-14 grid grid-cols-1 tablet-min:grid-cols-2 gap-px bg-eco-navy/10 border border-eco-navy/10 rounded-2xl overflow-hidden">
        <!-- 01 Bids & Offers -->
        <div class="bg-eco-cream-light p-8 flex flex-col gap-4">
          <div class="flex items-start justify-between">
            <span class="text-xs font-semibold text-eco-navy/40 tabular-nums">01</span>
            <div class="w-9 h-9 rounded-md bg-eco-gold/15 text-eco-gold flex items-center justify-center">
              <mat-icon class="!text-[18px] !w-[18px] !h-[18px]">gavel</mat-icon>
            </div>
          </div>
          <h3 class="text-2xl font-bold text-eco-navy">Bids &amp; Offers</h3>
          <p class="text-eco-navy/70 leading-relaxed text-sm">
            Post bids and offers with transparent pricing. Configurable by commodity,
            grade, delivery window, and location.
          </p>
          <ul class="mt-2 space-y-2 text-sm text-eco-navy">
            <li class="flex items-center gap-2"><mat-icon class="text-emerald-600 !text-[16px] !w-4 !h-4">check_circle</mat-icon> Custom commodity specs</li>
            <li class="flex items-center gap-2"><mat-icon class="text-emerald-600 !text-[16px] !w-4 !h-4">check_circle</mat-icon> Live market depth</li>
            <li class="flex items-center gap-2"><mat-icon class="text-emerald-600 !text-[16px] !w-4 !h-4">check_circle</mat-icon> Smart filters</li>
          </ul>
        </div>

        <!-- 02 Negotiations -->
        <div class="bg-eco-cream-light p-8 flex flex-col gap-4">
          <div class="flex items-start justify-between">
            <span class="text-xs font-semibold text-eco-navy/40 tabular-nums">02</span>
            <div class="w-9 h-9 rounded-md bg-eco-gold/15 text-eco-gold flex items-center justify-center">
              <mat-icon class="!text-[18px] !w-[18px] !h-[18px]">swap_horiz</mat-icon>
            </div>
          </div>
          <h3 class="text-2xl font-bold text-eco-navy">Negotiations</h3>
          <p class="text-eco-navy/70 leading-relaxed text-sm">
            Counter, accept, or decline in a clear bilateral thread. Full history of every
            round.
          </p>
          <ul class="mt-2 space-y-2 text-sm text-eco-navy">
            <li class="flex items-center gap-2"><mat-icon class="text-emerald-600 !text-[16px] !w-4 !h-4">check_circle</mat-icon> Threaded counters</li>
            <li class="flex items-center gap-2"><mat-icon class="text-emerald-600 !text-[16px] !w-4 !h-4">check_circle</mat-icon> Round-by-round price log</li>
            <li class="flex items-center gap-2"><mat-icon class="text-emerald-600 !text-[16px] !w-4 !h-4">check_circle</mat-icon> Side-by-side comparison</li>
          </ul>
        </div>

        <!-- 03 Trades -->
        <div class="bg-eco-cream-light p-8 flex flex-col gap-4">
          <div class="flex items-start justify-between">
            <span class="text-xs font-semibold text-eco-navy/40 tabular-nums">03</span>
            <div class="w-9 h-9 rounded-md bg-eco-gold/15 text-eco-gold flex items-center justify-center">
              <mat-icon class="!text-[18px] !w-[18px] !h-[18px]">trending_up</mat-icon>
            </div>
          </div>
          <h3 class="text-2xl font-bold text-eco-navy">Trades</h3>
          <p class="text-eco-navy/70 leading-relaxed text-sm">
            See trades done in the market and settled contracts. Filter by commodity or
            delivery window.
          </p>
          <ul class="mt-2 space-y-2 text-sm text-eco-navy">
            <li class="flex items-center gap-2"><mat-icon class="text-emerald-600 !text-[16px] !w-4 !h-4">check_circle</mat-icon> See historical trade data</li>
            <li class="flex items-center gap-2"><mat-icon class="text-emerald-600 !text-[16px] !w-4 !h-4">check_circle</mat-icon> Compare across different markets</li>
          </ul>
        </div>

        <!-- 04 Global Access -->
        <div class="bg-eco-cream-light p-8 flex flex-col gap-4">
          <div class="flex items-start justify-between">
            <span class="text-xs font-semibold text-eco-navy/40 tabular-nums">04</span>
            <div class="w-9 h-9 rounded-md bg-eco-gold/15 text-eco-gold flex items-center justify-center">
              <mat-icon class="!text-[18px] !w-[18px] !h-[18px]">public</mat-icon>
            </div>
          </div>
          <h3 class="text-2xl font-bold text-eco-navy">Global Access</h3>
          <p class="text-eco-navy/70 leading-relaxed text-sm">
            Reach buyers and sellers across North America and beyond. From
            domestic to export markets, all in one view.
          </p>
          <ul class="mt-2 space-y-2 text-sm text-eco-navy">
            <li class="flex items-center gap-2"><mat-icon class="text-emerald-600 !text-[16px] !w-4 !h-4">check_circle</mat-icon> Multi-market routing</li>
            <li class="flex items-center gap-2"><mat-icon class="text-emerald-600 !text-[16px] !w-4 !h-4">check_circle</mat-icon> Live basis updates</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================ -->
  <!-- D. Mobile app (cream) — phone mockup                           -->
  <!-- ============================================================ -->
  <section #forYouRef class="bg-eco-cream-light py-24">
    <div class="container mx-auto px-6">
      <div class="grid grid-cols-1 laptop-min:grid-cols-2 gap-16 items-center">
        <!-- Left copy -->
        <div>
          <div class="text-sm uppercase tracking-widest text-eco-gold font-semibold mb-3">On The Go</div>
          <h2 class="text-4xl tablet-max:text-3xl font-bold text-eco-navy leading-tight tracking-tight">
            The marketplace, in your pocket.
          </h2>
          <p class="mt-5 text-base text-eco-navy/70 leading-relaxed">
            Discover the ultimate trading experience with our advanced
            commodity trading app, designed to bring the world of commodity
            markets to your fingertips. Whether you're on the move or in the
            comfort of your home, our app ensures you never miss a trading
            opportunity.
          </p>
          <ul class="mt-6 space-y-3 text-eco-navy">
            <li class="flex items-center gap-3 text-sm"><mat-icon class="text-emerald-600 !text-[18px] !w-[18px] !h-[18px]">check_circle</mat-icon> Push notifications for counters &amp; settlements</li>
            <li class="flex items-center gap-3 text-sm"><mat-icon class="text-emerald-600 !text-[18px] !w-[18px] !h-[18px]">check_circle</mat-icon> One-tap accept &amp; counter</li>
            <li class="flex items-center gap-3 text-sm"><mat-icon class="text-emerald-600 !text-[18px] !w-[18px] !h-[18px]">check_circle</mat-icon> Real-time basis &amp; market data</li>
          </ul>
          <div class="mt-8 flex flex-wrap gap-3">
            <a
              [href]="iosAppLink"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center gap-3 bg-eco-navy text-white px-5 py-3 rounded-md hover:bg-eco-navy-700 transition-colors"
            >
              <fa-icon [icon]="faApple" size="2x"></fa-icon>
              <span class="flex flex-col leading-tight text-left">
                <span class="text-[10px] uppercase tracking-wider opacity-70">Download on</span>
                <span class="text-sm font-medium">App Store</span>
              </span>
            </a>
            <a
              [href]="androidAppLink"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center gap-3 bg-eco-navy text-white px-5 py-3 rounded-md hover:bg-eco-navy-700 transition-colors"
            >
              <fa-icon [icon]="faAndroid" size="2x"></fa-icon>
              <span class="flex flex-col leading-tight text-left">
                <span class="text-[10px] uppercase tracking-wider opacity-70">Get it on</span>
                <span class="text-sm font-medium">Google Play</span>
              </span>
            </a>
          </div>
        </div>

        <!-- Phone mockup -->
        <div class="flex justify-center">
          <div class="phone-frame relative">
            <div class="phone-notch"></div>
            <div class="phone-screen flex flex-col">
              <!-- Status bar -->
              <div class="px-6 pt-4 pb-2 flex items-center justify-between text-[11px] font-semibold text-eco-navy">
                <span>9:41</span>
                <span class="flex items-center gap-1">
                  <mat-icon class="!text-[12px] !w-3 !h-3">signal_cellular_alt</mat-icon>
                  <mat-icon class="!text-[12px] !w-3 !h-3">wifi</mat-icon>
                  <mat-icon class="!text-[12px] !w-3 !h-3">battery_full</mat-icon>
                </span>
              </div>
              <!-- App header -->
              <div class="px-4 py-2 flex items-center justify-between border-b border-gray-100">
                <mat-icon class="!text-[18px] !w-[18px] !h-[18px] text-eco-navy">menu</mat-icon>
                <span class="text-[10px] font-bold leading-tight text-eco-navy text-center">
                  Johnston's<br/>Connected
                </span>
                <mat-icon class="!text-[18px] !w-[18px] !h-[18px] text-eco-navy">notifications_none</mat-icon>
              </div>
              <!-- Search -->
              <div class="px-3 pt-3">
                <div class="bg-gray-100 rounded-full px-3 py-1.5 flex items-center gap-2">
                  <mat-icon class="!text-[12px] !w-3 !h-3 text-gray-400">search</mat-icon>
                  <span class="text-[10px] text-gray-400">Search...</span>
                </div>
              </div>
              <!-- Filter chips -->
              <div class="px-3 pt-2 flex gap-1 overflow-x-auto no-scrollbar">
                <span class="text-[9px] font-semibold px-2 py-0.5 rounded-full bg-eco-navy text-white">All</span>
                <span class="text-[9px] font-semibold px-2 py-0.5 rounded-full border border-gray-200 text-gray-500">Bids</span>
                <span class="text-[9px] font-semibold px-2 py-0.5 rounded-full border border-gray-200 text-gray-500">Offers</span>
                <span class="text-[9px] font-semibold px-2 py-0.5 rounded-full border border-gray-200 text-gray-500">Barley</span>
                <span class="text-[9px] font-semibold px-2 py-0.5 rounded-full border border-gray-200 text-gray-500">Corn</span>
                <span class="text-[9px] font-semibold px-2 py-0.5 rounded-full border border-gray-200 text-gray-500">Canola</span>
              </div>
              <!-- Listings -->
              <div class="flex-1 px-3 pt-2 space-y-1.5 overflow-hidden">
                <div class="phone-row">
                  <div class="flex-1">
                    <div class="text-[10px] font-bold text-eco-navy">Corn – Yellow No. 2</div>
                    <div class="text-[8px] text-gray-500">Jul 15 - Jul 22, 2026</div>
                    <div class="text-[8px] text-gray-500">Vancouver, BC · Delivered</div>
                  </div>
                  <div class="text-right">
                    <span class="inline-block text-[8px] font-bold px-1.5 py-0.5 rounded bg-emerald-500 text-white">BID</span>
                    <div class="text-[8px] text-gray-500 mt-0.5">2,209 MT</div>
                    <div class="text-[10px] font-bold text-eco-navy">CAD $156.00</div>
                  </div>
                </div>
                <div class="phone-row">
                  <div class="flex-1">
                    <div class="text-[10px] font-bold text-eco-navy">Barley – Feed</div>
                    <div class="text-[8px] text-gray-500">Aug 1 - Aug 31, 2026</div>
                    <div class="text-[8px] text-gray-500">Lethbridge, AB · FOB Farm</div>
                  </div>
                  <div class="text-right">
                    <span class="inline-block text-[8px] font-bold px-1.5 py-0.5 rounded bg-blue-500 text-white">OFFER</span>
                    <div class="text-[8px] text-gray-500 mt-0.5">1,548 MT</div>
                    <div class="text-[10px] font-bold text-eco-navy">CAD $302.50</div>
                  </div>
                </div>
                <div class="phone-row">
                  <div class="flex-1">
                    <div class="text-[10px] font-bold text-eco-navy">Canola – No. 1</div>
                    <div class="text-[8px] text-gray-500">Sep 5 - Sep 18, 2026</div>
                    <div class="text-[8px] text-gray-500">Saskatoon, SK · Delivered</div>
                  </div>
                  <div class="text-right">
                    <span class="inline-block text-[8px] font-bold px-1.5 py-0.5 rounded bg-emerald-500 text-white">BID</span>
                    <div class="text-[8px] text-gray-500 mt-0.5">3,100 MT</div>
                    <div class="text-[10px] font-bold text-eco-navy">CAD $682.20</div>
                  </div>
                </div>
                <div class="phone-row">
                  <div class="flex-1">
                    <div class="text-[10px] font-bold text-eco-navy">DDGS – Corn</div>
                    <div class="text-[8px] text-gray-500">Apr 19 - Apr 24, 2026</div>
                    <div class="text-[8px] text-gray-500">Lethbridge, AB · FOB Farm</div>
                  </div>
                  <div class="text-right">
                    <span class="inline-block text-[8px] font-bold px-1.5 py-0.5 rounded bg-blue-500 text-white">OFFER</span>
                    <div class="text-[8px] text-gray-500 mt-0.5">1,250 MT</div>
                    <div class="text-[10px] font-bold text-eco-navy">CAD $225.00</div>
                  </div>
                </div>
                <div class="phone-row">
                  <div class="flex-1">
                    <div class="text-[10px] font-bold text-eco-navy">Wheat – Durum CWAD</div>
                    <div class="text-[8px] text-gray-500">Sep 22 - Oct 5, 2026</div>
                    <div class="text-[8px] text-gray-500">Thunder Bay, ON · Delivered</div>
                  </div>
                  <div class="text-right">
                    <span class="inline-block text-[8px] font-bold px-1.5 py-0.5 rounded bg-emerald-500 text-white">BID</span>
                    <div class="text-[8px] text-gray-500 mt-0.5">1,800 MT</div>
                    <div class="text-[10px] font-bold text-eco-navy">CAD $412.00</div>
                  </div>
                </div>
                <div class="phone-row">
                  <div class="flex-1">
                    <div class="text-[10px] font-bold text-eco-navy">Chickpeas – Kabuli</div>
                    <div class="text-[8px] text-gray-500">Aug 12 - Aug 26, 2026</div>
                    <div class="text-[8px] text-gray-500">Swift Current, SK · FOB Farm</div>
                  </div>
                  <div class="text-right">
                    <span class="inline-block text-[8px] font-bold px-1.5 py-0.5 rounded bg-blue-500 text-white">OFFER</span>
                    <div class="text-[8px] text-gray-500 mt-0.5">420 MT</div>
                    <div class="text-[10px] font-bold text-eco-navy">CAD $915.50</div>
                  </div>
                </div>
              </div>
              <!-- Action buttons -->
              <div class="px-3 py-2 flex gap-2">
                <button class="flex-1 flex items-center justify-center gap-1 bg-emerald-500 text-white text-[10px] font-bold py-1.5 rounded-full">
                  <span>+ New Bid</span>
                </button>
                <button class="flex-1 flex items-center justify-center gap-1 bg-blue-500 text-white text-[10px] font-bold py-1.5 rounded-full">
                  <span>+ New Offer</span>
                </button>
              </div>
              <!-- Bottom tab bar -->
              <div class="px-2 py-1.5 border-t border-gray-100 grid grid-cols-4 text-center">
                <div class="flex flex-col items-center gap-0.5">
                  <mat-icon class="!text-[14px] !w-3.5 !h-3.5 text-eco-gold">trending_up</mat-icon>
                  <span class="text-[7px] font-semibold text-eco-gold">Market</span>
                </div>
                <div class="flex flex-col items-center gap-0.5">
                  <mat-icon class="!text-[14px] !w-3.5 !h-3.5 text-gray-400">swap_horiz</mat-icon>
                  <span class="text-[7px] font-semibold text-gray-400">Negotiate</span>
                </div>
                <div class="flex flex-col items-center gap-0.5">
                  <mat-icon class="!text-[14px] !w-3.5 !h-3.5 text-gray-400">description</mat-icon>
                  <span class="text-[7px] font-semibold text-gray-400">Contracts</span>
                </div>
                <div class="flex flex-col items-center gap-0.5">
                  <mat-icon class="!text-[14px] !w-3.5 !h-3.5 text-gray-400">person</mat-icon>
                  <span class="text-[7px] font-semibold text-gray-400">Profile</span>
                </div>
              </div>
              <!-- Home indicator -->
              <div class="pb-1.5 pt-1 flex justify-center">
                <div class="w-20 h-1 rounded-full bg-eco-navy/40"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================ -->
  <!-- E. Whichever side (farmers/traders)                            -->
  <!-- ============================================================ -->
  <section class="bg-eco-cream py-24">
    <div class="container mx-auto px-6">
      <div class="text-center max-w-3xl mx-auto">
        <div class="text-sm uppercase tracking-widest text-eco-gold font-semibold mb-3">Built for the way grain trades</div>
        <h2 class="text-4xl tablet-max:text-3xl font-bold text-eco-navy leading-tight tracking-tight">
          Whichever side of the<br />contract you're on.
        </h2>
      </div>

      <div class="mt-14 grid grid-cols-1 laptop-min:grid-cols-2 gap-8">
        <!-- For Farmers card -->
        <div class="rounded-2xl overflow-hidden bg-white shadow-sm border border-eco-navy/5">
          <div class="relative h-48 farmer-card-bg flex items-end p-6">
            <svg class="absolute inset-0 w-full h-full opacity-70" viewBox="0 0 400 200" preserveAspectRatio="xMidYMax slice">
              <g stroke="#9C7B40" stroke-width="1.5" stroke-linecap="round" fill="none" opacity="0.6">
                <g transform="translate(60,180)"><path d="M0 0 V -60"/><path d="M0 -30 L -10 -45"/><path d="M0 -30 L 10 -45"/><path d="M0 -45 L -8 -58"/><path d="M0 -45 L 8 -58"/></g>
                <g transform="translate(130,180)"><path d="M0 0 V -60"/><path d="M0 -30 L -10 -45"/><path d="M0 -30 L 10 -45"/><path d="M0 -45 L -8 -58"/><path d="M0 -45 L 8 -58"/></g>
                <g transform="translate(200,180)"><path d="M0 0 V -60"/><path d="M0 -30 L -10 -45"/><path d="M0 -30 L 10 -45"/><path d="M0 -45 L -8 -58"/><path d="M0 -45 L 8 -58"/></g>
                <g transform="translate(270,180)"><path d="M0 0 V -60"/><path d="M0 -30 L -10 -45"/><path d="M0 -30 L 10 -45"/><path d="M0 -45 L -8 -58"/><path d="M0 -45 L 8 -58"/></g>
                <g transform="translate(340,180)"><path d="M0 0 V -60"/><path d="M0 -30 L -10 -45"/><path d="M0 -30 L 10 -45"/><path d="M0 -45 L -8 -58"/><path d="M0 -45 L 8 -58"/></g>
              </g>
            </svg>
            <span class="relative z-10 inline-block bg-white text-eco-navy text-[11px] font-bold tracking-widest uppercase px-3 py-1.5 rounded">For Farmers</span>
          </div>
          <div class="p-8">
            <h3 class="text-2xl font-bold text-eco-navy mb-5">Sell your crop on your terms.</h3>
            <ul class="space-y-3 text-sm text-eco-navy">
              <li class="flex items-center gap-3"><mat-icon class="text-emerald-600 !text-[18px] !w-[18px] !h-[18px]">check_circle</mat-icon> Quickly find buyers for your commodities</li>
              <li class="flex items-center gap-3"><mat-icon class="text-emerald-600 !text-[18px] !w-[18px] !h-[18px]">check_circle</mat-icon> Transparent pricing and fair market access</li>
              <li class="flex items-center gap-3"><mat-icon class="text-emerald-600 !text-[18px] !w-[18px] !h-[18px]">check_circle</mat-icon> Verified, trustworthy partners</li>
              <li class="flex items-center gap-3"><mat-icon class="text-emerald-600 !text-[18px] !w-[18px] !h-[18px]">check_circle</mat-icon> One-on-one brokerage support, anytime</li>
            </ul>
          </div>
        </div>

        <!-- For Traders card -->
        <div class="rounded-2xl overflow-hidden bg-eco-navy shadow-sm border border-eco-navy/5">
          <div class="relative h-48 trader-card-bg flex items-end p-6">
            <div class="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-eco-gold/10"></div>
            <span class="relative z-10 inline-block bg-eco-navy-700 text-white text-[11px] font-bold tracking-widest uppercase px-3 py-1.5 rounded">For Traders</span>
          </div>
          <div class="p-8 text-white">
            <h3 class="text-2xl font-bold !text-white mb-5">Source supply with confidence.</h3>
            <ul class="space-y-3 text-sm">
              <li class="flex items-center gap-3"><mat-icon class="text-emerald-400 !text-[18px] !w-[18px] !h-[18px]">check_circle</mat-icon> Find the best deals instantly</li>
              <li class="flex items-center gap-3"><mat-icon class="text-emerald-400 !text-[18px] !w-[18px] !h-[18px]">check_circle</mat-icon> Access high-volume supply</li>
              <li class="flex items-center gap-3"><mat-icon class="text-emerald-400 !text-[18px] !w-[18px] !h-[18px]">check_circle</mat-icon> Efficient negotiation tools</li>
              <li class="flex items-center gap-3"><mat-icon class="text-emerald-400 !text-[18px] !w-[18px] !h-[18px]">check_circle</mat-icon> Live market data &amp; basis updates</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================ -->
  <!-- F. End-to-end trust (dark navy)                                -->
  <!-- ============================================================ -->
  <section class="bg-eco-navy text-white py-24 relative overflow-hidden">
    <div class="absolute top-0 right-0 w-2/3 h-full pointer-events-none opacity-40"
      style="background: radial-gradient(circle at 80% 20%, rgba(216,159,63,0.15), transparent 50%);">
    </div>
    <div class="container mx-auto px-6 relative z-10">
      <div class="max-w-3xl">
        <div class="text-sm uppercase tracking-widest text-eco-gold font-semibold mb-3">End-to-end</div>
        <h2 class="text-4xl tablet-max:text-3xl font-bold leading-tight tracking-tight !text-white">
          Verified partners. Trusted<br />counterparties. Real brokers.
        </h2>
        <p class="mt-5 text-base text-white/70 leading-relaxed">
          We don't just introduce you to traders — we make sure the deal gets done. Vetted
          counterparties, trusted commercial relationships, and direct phone access to
          experienced brokers, every day the market is open.
        </p>
      </div>

      <div class="mt-14 grid grid-cols-1 tablet-min:grid-cols-3 gap-6">
        <!-- 01 -->
        <div class="bg-eco-navy-700/60 border border-white/10 rounded-2xl p-6 relative">
          <span class="absolute top-4 right-5 text-[11px] font-semibold text-white/30 tabular-nums">01</span>
          <div class="w-10 h-10 rounded-md bg-eco-gold/15 text-eco-gold flex items-center justify-center mb-5">
            <mat-icon class="!text-[20px] !w-5 !h-5">verified_user</mat-icon>
          </div>
          <h3 class="text-lg font-bold !text-white mb-2">Verified Partners</h3>
          <p class="text-sm text-white/65 leading-relaxed">
            Every counterparty is retained and vetted by our brokerage team before they can trade.
          </p>
        </div>
        <!-- 02 -->
        <div class="bg-eco-navy-700/60 border border-white/10 rounded-2xl p-6 relative">
          <span class="absolute top-4 right-5 text-[11px] font-semibold text-white/30 tabular-nums">02</span>
          <div class="w-10 h-10 rounded-md bg-eco-gold/15 text-eco-gold flex items-center justify-center mb-5">
            <mat-icon class="!text-[20px] !w-5 !h-5">handshake</mat-icon>
          </div>
          <h3 class="text-lg font-bold !text-white mb-2">Trusted Buyers &amp; Sellers</h3>
          <p class="text-sm text-white/65 leading-relaxed">
            Counterparties drawn from established commercial relationships and 30+ years of
            brokerage network — trusted sources on both sides of the trade.
          </p>
        </div>
        <!-- 03 -->
        <div class="bg-eco-navy-700/60 border border-eco-gold/40 rounded-2xl p-6 relative">
          <span class="absolute top-4 right-5 text-[11px] font-semibold text-white/30 tabular-nums">03</span>
          <div class="w-10 h-10 rounded-md bg-eco-gold/15 text-eco-gold flex items-center justify-center mb-5">
            <mat-icon class="!text-[20px] !w-5 !h-5">smartphone</mat-icon>
          </div>
          <h3 class="text-lg font-bold !text-white mb-2">Traditional Brokerage</h3>
          <p class="text-sm text-white/65 leading-relaxed">
            Enjoy direct, one-on-one access to experienced brokers who provide real-time market
            insight to help you trade with confidence. In a tech-focused world, we want clients
            to know there are real people and brokers available anytime.
          </p>
          <button
            (click)="scrollToContact()"
            class="mt-4 text-eco-gold hover:text-eco-gold-hover text-sm font-semibold cursor-pointer"
          >
            Talk to a broker →
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================ -->
  <!-- G. About (cream)                                               -->
  <!-- ============================================================ -->
  <section #aboutRef class="bg-eco-cream py-24">
    <div class="container mx-auto px-6">
      <div class="max-w-4xl">
        <div class="text-sm uppercase tracking-widest text-eco-gold font-semibold mb-3">About us</div>
        <h2 class="text-4xl tablet-max:text-3xl font-bold text-eco-navy leading-tight tracking-tight">
          Founded in <span class="font-display-italic text-eco-gold">Calgary, 2022</span>. Built on <span class="font-display-italic text-eco-gold">30+ years</span> of grain brokerage experience.
        </h2>
        <p class="mt-6 text-base text-eco-navy/70 leading-relaxed">
          Johnston's Connected was founded in the fall of 2022 in Calgary, AB, with a commitment to bring
          together trustworthy commercial buyers and sellers of agricultural commodities — allowing quick and
          easy access to price discovery and trade execution in the North American grain market. With over 30
          years of grain brokerage experience, as well as diverse agricultural backgrounds including farming,
          cleaning/processing, feed, and commodity trading, Johnston's Connected ensures you are dealing with
          brokers that have the experience to provide the service you require.
        </p>
      </div>

      <div class="mt-12 grid grid-cols-2 laptop-min:grid-cols-4 gap-px bg-eco-navy/10 border-t border-eco-navy/10">
        <div class="bg-eco-cream p-6">
          <div class="text-2xl font-bold text-eco-navy">2022</div>
          <div class="mt-1 text-[11px] uppercase tracking-widest text-eco-navy/50 font-semibold">Founded</div>
        </div>
        <div class="bg-eco-cream p-6">
          <div class="text-2xl font-bold text-eco-navy">Calgary, AB</div>
          <div class="mt-1 text-[11px] uppercase tracking-widest text-eco-navy/50 font-semibold">Headquartered</div>
        </div>
        <div class="bg-eco-cream p-6">
          <div class="text-2xl font-bold text-eco-navy leading-tight">Domestic, Track, Export <span class="text-eco-gold">&amp; more</span></div>
          <div class="mt-1 text-[11px] uppercase tracking-widest text-eco-navy/50 font-semibold">Markets served</div>
        </div>
        <div class="bg-eco-cream p-6">
          <div class="text-2xl font-bold text-eco-navy">Verified</div>
          <div class="mt-1 text-[11px] uppercase tracking-widest text-eco-navy/50 font-semibold">Counterparties</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================ -->
  <!-- H. Contact (cream)                                             -->
  <!-- ============================================================ -->
  <section #contactRef class="bg-eco-cream-light py-24">
    <div class="container mx-auto px-6">
      <div class="grid grid-cols-1 laptop-min:grid-cols-2 gap-16">
        <!-- Left -->
        <div>
          <div class="text-sm uppercase tracking-widest text-eco-gold font-semibold mb-3">Get in touch</div>
          <h2 class="text-4xl tablet-max:text-3xl font-bold text-eco-navy leading-tight tracking-tight">
            Talk to a broker.
          </h2>
          <p class="mt-5 text-base text-eco-navy/70 leading-relaxed max-w-md">
            Have a question, want a market quote, or need help getting onto
            the platform? Send a note. We'll get back to you within one
            business day.
          </p>

          <div class="mt-10 grid grid-cols-2 gap-y-8 gap-x-6 max-w-md">
            <div>
              <div class="text-[11px] uppercase tracking-widest text-eco-gold font-semibold mb-1">Office</div>
              <div class="text-xs mobile-min:text-sm text-eco-navy">Suite 2800, 150 - 9th Ave. SW<br/>Calgary, AB T2P 3H9</div>
            </div>
            <div>
              <div class="text-[11px] uppercase tracking-widest text-eco-gold font-semibold mb-1">Phone</div>
              <div class="text-xs mobile-min:text-sm text-eco-navy">Toll Free 844.324.7778<br/>Fax 403.266.7965</div>
            </div>
            <div>
              <div class="text-[11px] uppercase tracking-widest text-eco-gold font-semibold mb-1">Email</div>
              <div class="text-xs mobile-min:text-sm text-eco-navy">info&#64;johnstonsconnected.com</div>
            </div>
            <div>
              <div class="text-[11px] uppercase tracking-widest text-eco-gold font-semibold mb-1">Hours</div>
              <div class="text-xs mobile-min:text-sm text-eco-navy">Mon–Fri · 6 AM – 5 PM MT<br/>Closed market holidays</div>
            </div>
          </div>
        </div>

        <!-- Right: form -->
        <div class="bg-white rounded-2xl shadow-lg shadow-eco-navy/5 p-8 tablet-min:p-10">
          <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-5">
            <div class="grid grid-cols-1 tablet-min:grid-cols-2 gap-5">
              <div>
                <label class="block text-[11px] uppercase tracking-widest text-eco-navy/60 font-semibold mb-2">Contact Name</label>
                <input
                  formControlName="contactName"
                  class="w-full bg-eco-cream-light border border-eco-navy/10 rounded-md px-3 py-2.5 text-sm text-eco-navy focus:border-eco-gold focus:outline-none focus:ring-1 focus:ring-eco-gold/30 transition-all"
                  placeholder="John Doe"
                />
              </div>
              <div>
                <label class="block text-[11px] uppercase tracking-widest text-eco-navy/60 font-semibold mb-2">Company</label>
                <input
                  formControlName="companyName"
                  class="w-full bg-eco-cream-light border border-eco-navy/10 rounded-md px-3 py-2.5 text-sm text-eco-navy focus:border-eco-gold focus:outline-none focus:ring-1 focus:ring-eco-gold/30 transition-all"
                  placeholder="Farm or trading company"
                />
              </div>
            </div>

            <div class="grid grid-cols-1 tablet-min:grid-cols-2 gap-5">
              <div>
                <label class="block text-[11px] uppercase tracking-widest text-eco-navy/60 font-semibold mb-2">Email</label>
                <input
                  type="email"
                  formControlName="email"
                  class="w-full bg-eco-cream-light border rounded-md px-3 py-2.5 text-sm text-eco-navy focus:outline-none focus:ring-1 transition-all"
                  [ngClass]="showError('email')
                    ? 'border-red-400 focus:border-red-400 focus:ring-red-400/30'
                    : 'border-eco-navy/10 focus:border-eco-gold focus:ring-eco-gold/30'"
                  placeholder="john@example.com"
                />
                @if (showError('email')) {
                  <p class="mt-1.5 text-xs text-red-500">
                    @if (contactUsForm.get('email')?.errors?.['required']) {
                      Email is required.
                    } @else {
                      Enter a valid email address, e.g. john&#64;example.com.
                    }
                  </p>
                }
              </div>
              <div>
                <label class="block text-[11px] uppercase tracking-widest text-eco-navy/60 font-semibold mb-2">Phone</label>
                <input
                  type="tel"
                  formControlName="phone"
                  class="w-full bg-eco-cream-light border rounded-md px-3 py-2.5 text-sm text-eco-navy focus:outline-none focus:ring-1 transition-all"
                  [ngClass]="showError('phone')
                    ? 'border-red-400 focus:border-red-400 focus:ring-red-400/30'
                    : 'border-eco-navy/10 focus:border-eco-gold focus:ring-eco-gold/30'"
                  placeholder="(555) 123-4567"
                />
                @if (showError('phone')) {
                  <p class="mt-1.5 text-xs text-red-500">
                    Enter a valid phone number with at least 10 digits.
                  </p>
                }
              </div>
            </div>

            <div>
              <label class="block text-[11px] uppercase tracking-widest text-eco-navy/60 font-semibold mb-2">I'm interested in</label>
              <div class="flex flex-wrap gap-2">
                @for (opt of interestedOptions; track opt) {
                  <button
                    type="button"
                    (click)="selectInterest(opt)"
                    [ngClass]="interestedIn() === opt
                      ? 'bg-eco-navy text-white border-eco-navy'
                      : 'bg-white text-eco-navy/70 border-eco-navy/15 hover:border-eco-navy/40'"
                    class="text-xs font-semibold px-4 py-1.5 rounded-full border transition-colors cursor-pointer"
                  >
                    {{ opt }}
                  </button>
                }
              </div>
            </div>

            <div>
              <label class="block text-[11px] uppercase tracking-widest text-eco-navy/60 font-semibold mb-2">Message</label>
              <textarea
                formControlName="message"
                rows="4"
                placeholder="How can we help?"
                class="w-full bg-eco-cream-light border border-eco-navy/10 rounded-md px-3 py-2.5 text-sm text-eco-navy focus:border-eco-gold focus:outline-none focus:ring-1 focus:ring-eco-gold/30 transition-all resize-none"
              ></textarea>
            </div>

            <button
              type="submit"
              [disabled]="contactUsForm.invalid"
              [class.opacity-50]="contactUsForm.invalid"
              class="w-full mt-2 flex items-center justify-center gap-1 bg-eco-gold hover:bg-eco-gold-hover text-eco-navy font-bold py-3 rounded-md shadow-md transition-colors cursor-pointer disabled:cursor-not-allowed"
            >
              Send message <mat-icon class="!text-base !w-5 !h-5">chevron_right</mat-icon>
            </button>

            <p class="text-center text-xs text-eco-navy/40">
              By submitting, you agree to our
              <a
                href="https://s3.ca-central-1.amazonaws.com/johnstonsconnected.com/legal/Terms+of+Use.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="underline hover:text-eco-gold"
              >terms</a>
              and
              <a
                href="https://s3.ca-central-1.amazonaws.com/johnstonsconnected.com/legal/Privacy+Policy-+Johnston's+Connected.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="underline hover:text-eco-gold"
              >privacy policy</a>.
            </p>
          </form>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================ -->
  <!-- I. Footer (dark navy) — inline                                 -->
  <!-- ============================================================ -->
  <footer class="bg-eco-navy text-white pt-16 pb-6">
    <div class="container mx-auto px-6">
      <div class="grid grid-cols-1 tablet-min:grid-cols-12 gap-10">
        <div class="tablet-min:col-span-5">
          <div class="flex items-end gap-2">
            <img
              src="../../../assets/app-icons/sun-mark.svg"
              alt="Johnston's Connected"
              class="h-10 w-10 object-contain"
            />
            <span class="font-medium text-white leading-tight text-2xl">
              Johnston's Connected<span class="text-eco-gold">.</span>
            </span>
          </div>
          <p class="mt-5 text-sm text-white/60 max-w-xs leading-relaxed">
            The modern commodity trading system. Built in Calgary
            to serve everything from domestic to export markets.
          </p>
        </div>

        <div class="tablet-min:col-span-2">
          <div class="text-[11px] uppercase tracking-widest text-white/40 font-semibold mb-4">Platform</div>
          <ul class="space-y-2 text-sm">
            <li><a (click)="router.navigate(['/login'])" class="text-white/80 hover:text-eco-gold cursor-pointer">Enter platform</a></li>
            <li><a (click)="scrollToPlatform()" class="text-white/80 hover:text-eco-gold cursor-pointer">Capabilities</a></li>
            <li><a (click)="scrollToForYou()" class="text-white/80 hover:text-eco-gold cursor-pointer">Mobile app</a></li>
          </ul>
        </div>

        <div class="tablet-min:col-span-2">
          <div class="text-[11px] uppercase tracking-widest text-white/40 font-semibold mb-4">Company</div>
          <ul class="space-y-2 text-sm">
            <li><a (click)="scrollToAbout()" class="text-white/80 hover:text-eco-gold cursor-pointer">About</a></li>
            <li><a (click)="scrollToContact()" class="text-white/80 hover:text-eco-gold cursor-pointer">Brokers</a></li>
            <li><a (click)="scrollToContact()" class="text-white/80 hover:text-eco-gold cursor-pointer">Contact</a></li>
          </ul>
        </div>

        <div class="tablet-min:col-span-3">
          <div class="text-[11px] uppercase tracking-widest text-white/40 font-semibold mb-4">Legal</div>
          <ul class="space-y-2 text-sm">
            <li>
              <a
                href="https://s3.ca-central-1.amazonaws.com/johnstonsconnected.com/legal/Terms+of+Use.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="text-white/80 hover:text-eco-gold cursor-pointer"
              >
                Terms of Use
              </a>
            </li>
            <li>
              <a
                href="https://s3.ca-central-1.amazonaws.com/johnstonsconnected.com/legal/Privacy+Policy-+Johnston's+Connected.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="text-white/80 hover:text-eco-gold cursor-pointer"
              >
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="mt-14 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-3 text-xs text-white/40">
        <span>© 2026 Johnston's Grain Ltd. All rights reserved.</span>
      </div>
    </div>
  </footer>
</div>
